import React from 'react'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import './style.css'

const ContactItem = ({ icon, labelKey, value, isLink = false, linkType = 'default' }) => {
    const { t } = useTranslation()

    const renderValue = () => {
        if (!isLink) return value

        if (linkType === 'email') {
            return <a href={`mailto:${value}`}>{value}</a>
        }

        if (linkType === 'url') {
            return (
                <a href={value} target="_blank" rel="noopener noreferrer">
                    {value}
                </a>
            )
        }

        return value
    }

    return (
        <div className="request-data-contact-item">
            <div className="contact-item-icon-wrapper">
                <Icon icon={icon} className="contact-item-icon" />
            </div>
            <div className="contact-item-details">
                <div className="contact-item-label">{t(labelKey)}</div>
                <div className="contact-item-value">
                    {renderValue()}
                </div>
            </div>
        </div>
    )
}

export default ContactItem

